export const getTextFields = (studentData: any) => {
  const studentClass = studentData?.studentClass?.[0];
return [
  {
    id: "student-name",
    name: "name",
    label: "Name",
    type: "text",
    required: true,
    capitalizedFirst: true,
    value: studentData?.name || "",
  },
  {
    id: "student-class",
    name: "class",
    label: "Class",
    type: "text",
    required: true,
    value: studentClass?.class?.displayName || "Not Assigned",
  },
  {
    id: "student-rollnumber",
    name: "rollNumber",
    label: "Roll Number",
    type: "text",
    required: true,
    value: studentClass?.rollNumber || "Not Available",
  },
  {
    id: "parent-name",
    name: "parentName",
    label: "Parent Name",
    type: "text",
    required: true,
    value:studentData?.parent?.name || "Not Available",
  },
  {
    id: "parent-phone",
    name: "parentPhone",
    label: "Parent Phone",
    type: "text",
    required: true,
    value: studentData?.parent?.phone || "Not Available",
  },
];
};
